import { platformApi } from "@/api/http";

export interface CatalogService {
  id: number;
  name: string;
  description?: string;
  duration: number;
  price: number;
  categoryId?: number;
  categoryName?: string;
  active: boolean;
}

export interface CatalogCategory {
  id: number;
  name: string;
  services: CatalogService[];
}

interface UserCatalogServiceDto {
  userId: number;
  catalogServiceId: number;
  catalogService: {
    id: number;
    name: string;
    categoryId: number | null;
    categoryName: string | null;
    duration: number;
    price: number;
    description: string | null;
    active: boolean;
  };
}

const basePath = (businessId: string) =>
  `/api/v1/businesses/${businessId}`;

export const catalogApi = {
  /**
   * Get services assigned to a specific staff member, grouped by category.
   */
  getMyServices: async (businessId: string, userId: number): Promise<CatalogCategory[]> => {
    const { data } = await platformApi.get<UserCatalogServiceDto[]>(
      `${basePath(businessId)}/users/${userId}/user-catalog-services`,
    );
    const items = Array.isArray(data) ? data : [];

    // Group by category
    const categoryMap = new Map<number, CatalogCategory>();
    const NO_CATEGORY_ID = -1;

    for (const item of items) {
      const svc = item.catalogService;
      if (!svc || !svc.active) continue;

      const catId = svc.categoryId ?? NO_CATEGORY_ID;
      const catName = svc.categoryName ?? "Sin categoría";

      if (!categoryMap.has(catId)) {
        categoryMap.set(catId, { id: catId, name: catName, services: [] });
      }
      categoryMap.get(catId)!.services.push({
        id: svc.id,
        name: svc.name,
        description: svc.description ?? undefined,
        duration: svc.duration,
        price: svc.price,
        categoryId: svc.categoryId ?? undefined,
        categoryName: svc.categoryName ?? undefined,
        active: svc.active,
      });
    }

    return Array.from(categoryMap.values());
  },
};
